import React from "react";
import "./Hero.css";
import Banner from "../assets/hero-img2.png";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="hero">
      <div className="container">
        {/* Left Side */}
        <div className="left">
          <h1>Invest In Digital Assets Today</h1>
          <p>
            Lehumo is making it easy for ordinary South Africans to build wealth
            with digital assets and currencies. Our mission equip citizens from
            disadvantaged areas with knowledge regarding digital assets and
            currencies.
          </p>
          <div className="input-container">
            <Link to="/Signup">
              <button className="btn">Get Started</button>
            </Link>
            <Link to="/Login">
              <button className="btn">Sign in</button>
            </Link>
          </div>
        </div>

        {/* Right Side */}
        <div className="right">
          <div className="img-container">
            <img src={Banner} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
